const Vscode = () => {
    return (
        <div className="flex z-auto">
            <img src="../../vsc.png" className="h-[20em]" style={{position:'absolute', top: '50%', left:'50%', transform: 'translate(-50%, -50%)', opacity:'50%' }} alt="Vs code" />
        </div>
    );
}

export default Vscode;